export function getSessionId() {
  // ✅ ONLY use localStorage - no cookie fallback
  let sessionId = localStorage.getItem('ourpickup_session');
  
  if (!sessionId) {
    sessionId = 'sess_' + crypto.randomUUID();
    localStorage.setItem('ourpickup_session', sessionId);
  }
  
  return sessionId;
}

export function getAnonymousId() {
  let anonymousId = localStorage.getItem('ourpickup_anonymous');
  if (!anonymousId) {
    anonymousId = 'anon_' + crypto.randomUUID().substring(0, 8);
    localStorage.setItem('ourpickup_anonymous', anonymousId);
  }
  return anonymousId;
}

export function getSessionHeaders() {
  return {};
}

export async function trackEducation(modalType, action, data = {}) {
  try {
    const response = await fetch('/api/session/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        modalType,
        action,
        ...data
      })
    });
    return await response.json();
  } catch (error) {
    console.error('Error tracking education:', error);
    return null;
  }
}

export async function getSessionStatus() {
  try {
    const response = await fetch('/api/session/status');
    return await response.json();
  } catch (error) {
    console.error('Error getting session status:', error);
    return null;
  }
}

export async function transferSession(userId) {
  try {
    const response = await fetch('/api/session/transfer', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId })
    });
    return await response.json();
  } catch (error) {
    console.error('Error transferring session:', error);
    return null;
  }
}
